var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
var fontStylesMap = {
    display: 'font-display text-md-head-m md:text-md-head-d',
    sans: 'font-sans text-sm-med-m md:text-sm-med-d',
};
function VariablePrice(_a) {
    var _b = _a.activeColorStyle, activeColorStyle = _b === void 0 ? 'text-deco-dark-blue' : _b, className = _a.className, fontStyle = _a.fontStyle, _c = _a.inactiveColorStyle, inactiveColorStyle = _c === void 0 ? 'text-state-inactive-dark' : _c, _d = _a.outOf, outOf = _d === void 0 ? 4 : _d, priceLevel = _a.priceLevel;
    return (_jsx("div", __assign({ className: clsx(fontStylesMap[fontStyle], className) }, { children: Array.from({ length: outOf }).map(function (_, index) { return (_jsx("span", __assign({ className: "".concat(index <= priceLevel - 1 ? activeColorStyle : inactiveColorStyle, " rounded-full") }, { children: "$" }), index)); }) })));
}
export default VariablePrice;
